import VueRouter from 'vue-router'
import Vue from 'vue'
import AboutComponent from '../views/layouts/pages/AboutComponent'
import TechnologyComponent from '../views/layouts/pages/TechnologyComponent'
import ContactComponent from '../views/layouts/pages/ContactComponent'
import FaqComponent from '../views/layouts/pages/FaqComponent'
import HowToUseComponent from '../views/layouts/pages/HowToUseComponent'


Vue.use(VueRouter);

const router = new VueRouter({
    routes:
        [
            {
                path:"/bienvenue",
                component:AboutComponent,
            },
            {
                path:"/technologie",
                component:TechnologyComponent,
            },
            {
                path:"/contact",
                component:ContactComponent,
            },
            {
                path:"/faq",
                component:FaqComponent,
            },
            {
                path:"/how",
                component:HowToUseComponent,
            },

        ],
    mode: 'abstract'
})
export default router
